module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hidden-print hidden-xs hidden-sm"
  }, [_c('nav', {
    directives: [{
      name: "scroll",
      rawName: "v-scroll",
      value: (_vm.checkScroll),
      expression: "checkScroll"
    }],
    staticClass: "bs-docs-sidebar",
    class: {
      affix: _vm.affixed
    },
    style: ({
      marginTop: _vm.top
    })
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-1e3e7506", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1e3e7506!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Affix.vue
// module id = 74
// module chunks = 0